import { BaseContext } from '../../../utils/basecontext';
import { HttpClient } from '../../../utils/httpclient/httpclient';
import { GET, APIImpl } from '../api';
import { FeaturedCategoriesRequest } from './featuredcategoriesrequest';

export class FeaturedCategoriesAPI extends APIImpl<FeaturedCategoriesRequest>
{
    constructor(httpClient:HttpClient, appContext: BaseContext){
        super(httpClient, appContext);
    }

    getHttpMethod(){
        return GET;
    }

    getAPIURL(): string
    {
        // https://www.callertunes.etisalat.ae/Middleware/api/adapter/v1/crbt/get-recommendation-songs
        return "get-recommendation-songs"+"?"+"language="+ this.getRequest().getFeaturedCategoriesRequest().getLanguage()+"&"+
        "msisdn=" + this.getRequest().getFeaturedCategoriesRequest().getMsisdn() +"&"+ 
        "clientTxnId="+ "clientTxnId" +"&"+ 
        "identifier="+ this.getRequest().getFeaturedCategoriesRequest().getIdentifier();
    }

    /* getHttpHeaders():string
    {
       let baseHeaders = super.getHttpHeaders();

        let featuredCategoryHeader = {
            "identifier": this.getRequest().getFeaturedCategoriesRequest().getIdentifier(),
            "msisdn": this.getRequest().getFeaturedCategoriesRequest().getMsisdn()
        } as any; 

        let combinedHeaders = Object.assign(featuredCategoryHeader, baseHeaders);

        return combinedHeaders;
    } */
    
   /*  getRequestData()
    {
        return "clientTxnId="+ this.getRequest().getFeaturedCategoriesRequest().getClientTxnId() +"&"+ 
               "language="+ this.getRequest().getFeaturedCategoriesRequest().getLanguage();
    } */
}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/featuredcategories/featuredcategoriesapi.tsx